import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useTemplate(id) {
  const [template, setTemplate] = useState();

  useEffect(() => {
    axios
      .get(routes.api.managers.programs.show(id))
      .then((response) => setTemplate(response.data.data));
  }, []);

  return template;
}
